import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Floor } from '../../../model/areas_response';
import { useSessionStore } from '../../../context/session';
import styles from './floor_button.module.scss';
import { RobotIcon, WorkersIcon } from '../workers_icon/workers_icon';
import { WorkerResponse } from '../../../model/workers_response';

/**
 * フロアボタンのプロパティ
 */
export interface FloorIconProps {
  /** フロア情報 */
  floorInfo: Floor;
  /** 作業員情報 */
  workers?: WorkerResponse;
}

/**
 * フロアボタン
 * @param floorInfo
 * @param workers
 * @constructor
 */
export const FloorButton : React.FC<FloorIconProps> = ({ floorInfo, workers }) => {

  const { setSelectedFloorId, selectedFloorId } = useSessionStore((selector) => selector);

  const onClick = (id: number) => {
    setSelectedFloorId(id);
  };

  return (
      <div 
        className = { (floorInfo.id === selectedFloorId) ? styles.content + ' ' + styles.active : styles.content} onClick = {() => onClick(floorInfo.id)} 
        data-active={(floorInfo.id === selectedFloorId)}
        data-testid={`floorbutton-${floorInfo.id}`}
        >
        <div className = { (floorInfo.id === selectedFloorId) ? styles.floor + ' ' + styles.active : styles.floor}>
          {floorInfo.name}
        </div>
        <div className = {styles.icons}>
            {workers?.robots.filter((robot) => robot.floorId === floorInfo.id).map((robot) => <RobotIcon robot={robot} key={robot.robotId} />)}
            {workers?.workers.filter((worker) => worker.floorId === floorInfo.id).map((worker) => <WorkersIcon worker={worker} key={worker.deviceId} />)}
        </div>
        <div className = {(floorInfo.id === selectedFloorId) ? styles.arrow + ' ' + styles.active : styles.arrow}>
          <RightOutlined style={{ fontSize: '26px' }}/>
        </div>
      </div>
  );
};
